/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBNATUREOFPERSON = {
    ClosedCorporation: 'CC',
    CorporateEstateOrLiquidation: 'CE',
    ForeignListedCompany: 'FLC',
    ForeignStateOwnedEnterprise: 'FSOE',
    ForeignUnlistedCompany: 'FUC',
    ListedCompany: 'LC',
    OtherCompany: 'OC',
    RetirementFund: 'RF',
    StateOwnedEnterprise: 'SOE',
    UnlistedCompany: 'UC',
    Individual: 'I',
    AsylumSeeker: 'AS',
    Refugee: 'R',
    ForeignIndividual: 'FI',
    IndividualEstates: 'IE',
    AssociationNotForGain: 'ANFG',
    ChurchOrReligiousOrganisation: 'CRO',
    Club: 'C',
    SchoolOrUniversity: 'SSU',
    Society: 'SO',
    Stokvel: 'STO',
    UnincorporatedBodyOfPersons: 'UBOP',
    Trust: 'T',
    TestamentaryTrust: 'TT',
    SpecialTrustA1: 'ST1',
    SpecialTrustA2: 'ST2',
    ForeignTrust: 'FT'
} as const;
export type GHUBNATUREOFPERSON = typeof GHUBNATUREOFPERSON[keyof typeof GHUBNATUREOFPERSON];


export function GHUBNATUREOFPERSONFromJSON(json: any): GHUBNATUREOFPERSON {
    return GHUBNATUREOFPERSONFromJSONTyped(json, false);
}

export function GHUBNATUREOFPERSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBNATUREOFPERSON {
    return json as GHUBNATUREOFPERSON;
}

export function GHUBNATUREOFPERSONToJSON(value?: GHUBNATUREOFPERSON | null): any {
    return value as any;
}

